import { HStack } from '@rbilabs/universal-components';

import Link from 'components/link';

export const StyledLink = Link.withConfig({
  borderBottomWidth: '1px',
  borderStyle: 'solid',
  borderBottomColor: `${Styles.color.grey.four}`,
  width: '100%',
  color: Styles.color.grey.one,
  paddingX: '0',
  paddingY: '5',
  _web: {
    cursor: 'pointer',
  },
});

export const Row = HStack.withConfig({
  justifyContent: 'space-between',
  alignItems: 'center',
  width: '100%',
});
